import React, { memo } from 'react';
import styled from '@emotion/styled';
import { withTranslate } from '../../../../../shared/i18n/translate';
import themed from '../../../../../../ui/themer/themed';
import { Column, ColumnHeader } from './Column';

interface IProps {
	gate: string;
	role?: 'columnheader' | 'cell';
}

export const StyledGateColumn = styled(({ role = 'columnheader', ...props }) =>
	role === 'columnheader' ? <ColumnHeader {...props} /> : <Column {...props} />,
)`
	color: ${themed(({ color }) => color.text.default)};
	font-weight: 700;

	min-width: 130px;
	max-width: 170px;

	@media (max-width: 1024px) {
		display: none;
	}
`;

export const GateColumn = memo(
	withTranslate<IProps>(({ gate, role }) => (
		<StyledGateColumn role={role}>{gate}</StyledGateColumn>
	)),
);
